<template>
  <div class="mobile-product-card-layout">
    <div class="top-section">
      <slot name="top-section" />
    </div>
    <div class="bottom-section">
      <div class="content">
        <slot name="content" />
      </div>
      <div class="footer">
        <slot name="footer" />
      </div>
    </div>
    <slot name="date" />
  </div>
</template>

<style scoped lang="scss">
.mobile-product-card-layout {
  display: grid;
  grid-auto-rows: 1fr;

  border-radius: var(--border-radius-12);
  border: 1px solid var(--color-secondary-93);
  background-color: var(--color-white);
  overflow: hidden;
  width: calc(100% - 30px);
  position: relative;

  .top-section {
    width: 100%;
    min-width: 0;
    height: auto;
  }

  .bottom-section {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-width: 0;

    .content {
      border-bottom: unset;
      border-bottom-left-radius: unset;
      flex: 1;
    }

    .footer {
      border: unset;
      border-bottom-left-radius: var(--border-radius-12);
      border-top-right-radius: unset;
    }
  }
}
</style>
